import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=97946656&scoped=true"
import script from "./Crumb.vue?vue&type=script&lang=js"
export * from "./Crumb.vue?vue&type=script&lang=js"
import style0 from "./Crumb.vue?vue&type=style&index=0&id=97946656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97946656",
  null
  
)

export default component.exports